import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is it legal to do this?',
    a: 'Absolutely. It is your constitutional right as a property owner to appeal an assessment you believe to be incorrect.'
  }, {
    q: 'Can they raise my taxes if I complain?',
    a: "It is extremely unlikely. To raise your tax, the County would have to admit their own original assessment was 'too low,' which almost never happens in residential appeals."
  }, {
    q: 'How much time does it take?',
    a: "Gathering your info takes one afternoon. The County's internal process typically takes 30 to 90 days to reflect on your bill."
  }];
  return <section className="bg-cream py-20 px-4 md:px-8 border-t border-gray-200" data-id="element-6">
      <div className="max-w-3xl mx-auto" data-id="element-7">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-8">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-9">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-10">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} index={i} data-id="element-11" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-12">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-gray-50 transition-colors focus:outline-none" aria-expanded={isOpen} data-id="element-13">
        <span className="text-xl font-bold text-navy pr-8" data-id="element-14">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 text-gold" data-id="element-15">
          <ChevronDown className="w-6 h-6" data-id="element-16" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-17">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-18">
            <div className="px-6 pb-6 pt-2 text-lg text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-19">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}